// extracted by mini-css-extract-plugin
export default {"PageProduct":"PageProduct_PageProduct__5qRvs","PageProductSectionsWrapper":"PageProduct_PageProductSectionsWrapper__gZ1LK"};